import React from 'react'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'

import TextRenderer from '../TextRenderer'
import Image from '../Image'

import styles from './styles.module.scss'

const TextWithImage = (props) => {

    let imageSize = props.blok.image_width || 30
    let imageMaxWidth
    
    if (typeof window != 'undefined') {
        imageMaxWidth = Math.ceil((imageSize * window.innerWidth) / 100)
    } else {
        imageMaxWidth = Math.ceil((imageSize * 1440) / 100)
    }

    const imageClasses = classnames({
        [styles['text-with-image__image-wrapper']]: true,
        [styles['text-with-image__image-wrapper--left']]: props.blok.reverse
    })

    const containerClasses = classnames({
        [styles['text-with-image__container']]: true,
        [styles['text-with-image__container--right']]: props.blok.reverse
    })

    return (
        <SbEditable content={props.blok}>
            <section className={styles['text-with-image']} style={{ backgroundColor: props.blok.background_color }}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <div className={styles['text-with-image__inner']}>
                    <div className={`container ${containerClasses}`}>
                        <TextRenderer text={props.blok.copy} className={styles['text-with-image__description']} />
                    </div>
                    <div className={styles['text-with-image__content-bg']}></div>
                    <figure className={imageClasses} style={{ width: `${imageSize}%` }}>
                        <Image image={props.blok.image} className={styles['text-with-image__image']} blok={props.blok} params={{ maxWidth: imageMaxWidth }} />
                    </figure>
                </div>
            </section>
        </SbEditable>
    )
}

export default TextWithImage
